import { useI18n } from '../context/I18nContext';
import { useCategories } from '../hooks/useCategories';
import { LEAD_STATUS_DISPLAY_ORDER, LEAD_STATUS_I18N_KEYS } from './statusUtils';

export const useLeadOptions = () => {
  const { t } = useI18n();
  const sectorCategories = useCategories('sector');
  const sectorOptions = sectorCategories.getOptions();
  const allSectorOptions = sectorCategories.getAllOptions(t('leads.allSectors'));

  const statusOptions = LEAD_STATUS_DISPLAY_ORDER.map((value) => ({
    value,
    label: t(LEAD_STATUS_I18N_KEYS[value]),
  }));
  const allStatusOptions = [{ value: '', label: t('leads.allStatuses') }, ...statusOptions];

  const directionOptions = [
    { value: '', label: t('leads.chooseDirection') },
    { value: 'inbound', label: 'Inbound' },
    { value: 'outbound', label: 'Outbound' },
  ];

  return {
    statusOptions,
    allStatusOptions,
    sectorOptions,
    allSectorOptions,
    getSectorLabel: sectorCategories.getLabel,
    getSectorById: sectorCategories.getById,
    refreshSectors: sectorCategories.refresh,
    directionOptions,
  };
};
